import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';

export const useGetUserName = (fulfillmentPlanId) => {
  return useSelector((state) => {
    const verificationStatus = Global.selectEntitiesFulfillmentPlanProperty(state, { fulfillmentPlanId, property: 'verificationStatus' });
    const currentUser = Global.selectSellerUserById(state, {
      userId: verificationStatus?.verifiedByGuid,
    });
    return currentUser?.name;
  });
};

export const useIsVerified = (fulfillmentPlanId) => {
  return useSelector((state) => {
    const verificationStatus = Global.selectEntitiesFulfillmentPlanProperty(state, { fulfillmentPlanId, property: 'verificationStatus' });
    return verificationStatus?.verifiedUtc && verificationStatus?.verifiedByGuid;
  });
};

export const useGetVerifiedDateUtc = (fulfillmentPlanId) => {
  return useSelector((state) => {
    const verificationStatus = Global.selectEntitiesFulfillmentPlanProperty(state, { fulfillmentPlanId, property: 'verificationStatus' });
    return verificationStatus?.verifiedUtc;
  });
};
